import script from "./BillingDataPaid.PlanInfo.Monthly.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingDataPaid.PlanInfo.Monthly.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__